<template>
    <div :style="screenHeight">
        <iframe id="show-iframe" frameborder="0" scrolling="auto" style="background-color:transparent; position：absolute;width: 100%;
        height:100%; top: 0;left:0;bottom:0;" v-for="(item,index) in thirdPopupAddressList" 
        v-show="pageCode==item.id" v-if="item.isShow" :key="index" :src="item.address"></iframe>
      </div>
</template>

<script>
  import {publicFunClass} from '@/components/js/PublicFunClass.js'
  export default {
    name: "ThirdPopPage",
    mixins:[publicFunClass],
    props:{
      pageCode:String,
      thirdPopupAddressList: Array
    },
    data(){
      return {
        screenHeight:{height:''},
      }
    },
    created(){
      this.screenHeight.height=this.mountHeight(91);
    },
  }
</script>
<style scoped></style>


// WEBPACK FOOTER //
// src/components/loginHeadMange/ThirdPopPage.vue